<template>
  <div>
    <b-row>
      <DxDataGrid
        :show-row-lines="true"
        :show-column-lines="true"
        :show-borders="true"
        :row-alternation-enabled="true"
        :rtl-enabled="true"
        :data-source="sounds"
        :columns="fields"
        :remote-operations="true"
        :column-auto-width="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        column-resizing-mode="widget"
        :hover-state-enabled="true"
        :noDataText="checkData"
        @toolbar-preparing="onToolbarPreparing($event)"
        key-expr="id"
        class="ps_Table"
        :height="dataGridHeight"
      >
        <DxSearchPanel
          :visible="true"
          :width="240"
          :placeholder="label.pages.search"
        />
        <template #btnGroup>
          <div>
            <b-row class="ms-1">
              <b-col cols="auto" class="px-1">
                <b-button
                  variant="ps-danger"
                  class="py-1 pb-2"
                  size="sm"
                  v-b-tooltip.hover
                  :title="label.buttons.recycleBin"
                  @click="trashOpen"
                >
                  <b-icon icon="trash" scale="1.3" color="#fff"></b-icon>
                </b-button>
              </b-col>
              <b-col cols="auto" class="px-1">
                <b-button
                  variant="ps-success"
                  class="py-1 pb-2"
                  size="sm"
                  v-b-tooltip.hover
                  :title="label.pages.newGalleryVoice"
                  @click="add"
                >
                  <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                </b-button>
              </b-col>
              <b-col cols="auto" class="px-0">
                <b-button
                  variant="ps-secondary"
                  class="py-1 pb-2"
                  size="sm"
                  v-b-tooltip.hover
                  :title="label.buttons.reload"
                  @click="reloadContent"
                >
                  <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
        <template #btnRGroup>
          <b-row class="btnRLanguage-wrapper"  v-show="contentLanguageAccess == 1">
            <b-col cols="3">
              <label for="language" class="ps_label">
                {{ label.pages.contentLanguage }}
              </label>
            </b-col>
            <b-col cols="9">
              <v-select
                input-id="language"
                :options="languages"
                v-model="selectedLanguage"
                :reduce="(group) => group.id"
                :clearable="false"
                size="sm"
                class="ps_select"
                @input="setLanguage"
              >
              </v-select>
            </b-col>
          </b-row>
        </template>
        <template #radif="{ data }">
          <div>
            {{ data.rowIndex + 1 }}
          </div>
        </template>
        <template #image="{ data }">
          <div>
            <img :src="data.data.imageAddress" class="ps_table_inside_img" />
          </div>
        </template>
        <template #actions="{ data }">
          <b-row class="justify-content-center">
            <b-col cols="auto" class="px-0">
              <button @click="edit(data)" :id="'editBtnTlp-' + data.data.id">
                <b-icon
                  icon="dash-square-fill"
                  scale="1.1"
                  variant="ps-edit-icon"
                ></b-icon>
              </button>
              <b-tooltip
                boundary="#app"
                noninteractive
                triggers="hover"
                :target="'editBtnTlp-' + data.data.id"
              >
                {{ label.buttons.edit }}
              </b-tooltip>
            </b-col>
            <b-col cols="auto" class="px-0 pe-2">
              <button
                @click="delConfirm(data)"
                :id="'deleteBtnTlp-' + data.data.id"
              >
                <b-icon
                  icon="x-square-fill"
                  scale="1.1"
                  variant="ps-delete-icon"
                ></b-icon>
              </button>
              <b-tooltip
                boundary="#app"
                noninteractive
                triggers="hover"
                :target="'deleteBtnTlp-' + data.data.id"
              >
                {{ label.buttons.delete }}
              </b-tooltip>
            </b-col>
            <b-col cols="auto" class="px-0 pe-2">
              <button @click="show(data)" :id="'showBtnTlp-' + data.data.id">
                <b-icon
                  icon="filter-square-fill"
                  scale="1.1"
                  variant="ps-tools-icon"
                ></b-icon>
              </button>
              <b-tooltip
                boundary="#app"
                noninteractive
                triggers="hover"
                :target="'showBtnTlp-' + data.data.id"
              >
                {{ label.pages.showAlbum }}
              </b-tooltip>
            </b-col>
          </b-row>
        </template>
        <DxLoadPanel :enabled="true" />
        <DxScrolling mode="virtual" />
      </DxDataGrid>
    </b-row>

    <!--  Add Sound Modal -->
    <b-modal
      dir="rtl"
      v-model="addModal"
      header-bg-variant="ps-success"
      centered
      size="md"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.pages.newGalleryVoice }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="addModal = false"
          id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-4"  v-show="contentLanguageAccess == 1">
          <b-col class="align-self-center" cols="3">
            <label for="title" class="ps_label">
              {{ label.pages.contentLanguage }}
            </label>
          </b-col>
          <b-col class="align-self-center" cols="9">
            <v-select
              id="language"
              :options="languages"
              v-model="selectedLanguage"
              :reduce="(group) => group.id"
              size="sm"
              :clearable="false"
              class="ps_select"
              disabled
            >
            </v-select>
          </b-col>
        </b-row>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="title" class="ps_label">
              {{ label.pages.title }}
              <span class="ps_label_star">*</span>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="title" size="sm" v-model="form.galleryTitle" />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col>
            <b-row class="my-3">
              <b-col sm="3">
                <label for="desc" class="ps_label">
                  {{ label.pages.description }}
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-textarea
                  id="desc"
                  size="sm"
                  v-model="form.galleryDescription"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col class="align-self-center" cols="3">
            <label for="categories" class="ps_label">
              {{ label.pages.category }}
            </label>
          </b-col>
          <b-col cols="9" class="align-self-center" dir="rtl">
            <treeselect
              id="categories"
              :options="categories"
              :placeholder="label.pages.search"
              v-model="form.categories"
              :normalizer="normalizer"
              :flat="true"
              multiple
              :noOptionsText="label.errors.emptyList"
            ></treeselect>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="priority" class="ps_label">
              {{ label.form.priority }}
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-spinbutton
              id="priority"
              v-model="form.priority"
              size="sm"
              min="1"
              max="100"
            />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col cols="3">
            <label for="tags" class="ps_label">
              {{ label.form.tags }}
            </label>
          </b-col>
          <b-col cols="9">
            <v-select
              id="tags"
              v-model="form.tags"
              :closeOnSelect="false"
              size="sm"
              taggable
              multiple
              class="ps_select"
            >
              <template #no-options>
                {{ label.pages.Enter }}
              </template>
            </v-select>
          </b-col>
        </b-row>
        <b-row v-if="dropZoneAction" class="my-3">
          <b-col sm="3">
            <label for="image" class="ps_label">{{
              label.pages.preview
            }}</label>
          </b-col>
          <b-col sm="auto">
            <drop-zone-custom
              mode="image"
              :isRequired="true"
              :add="dropZoneAction"
              :edit="!dropZoneAction"
              :editSrc="form.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row v-if="!dropZoneAction" class="my-3">
          <b-col sm="12">
            <drop-zone-custom
              mode="image"
              :isRequired="true"
              :add="dropZoneAction"
              :edit="!dropZoneAction"
              :editSrc="form.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col sm="3">
            <label for="Display" class="ps_label">
              {{ label.form.display }}
            </label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input id="Display" type="checkbox" v-model="form.isConfirm" />
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="addModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addSound"
            >
              {{ label.buttons.recordInfo }}
            </b-button>
            <b-button
              v-else
              variant="ps-success"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Sound Modal -->
    <b-modal
      dir="rtl"
      v-model="editModal"
      header-bg-variant="ps-warning"
      centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.captions.editSoundGallery }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="editModal = false"
          id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="title" class="ps_label">
              {{ label.pages.title }}
              <span class="ps_label_star">*</span>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="title" size="sm" v-model="form.galleryTitle" />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col>
            <b-row class="my-3">
              <b-col sm="3">
                <label for="desc" class="ps_label">
                  {{ label.pages.description }}
                </label>
              </b-col>
              <b-col sm="9">
                <b-form-textarea
                  id="desc"
                  size="sm"
                  v-model="form.galleryDescription"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col class="align-self-center" cols="3">
            <label for="categories" class="ps_label">
              {{ label.pages.category }}
            </label>
          </b-col>
          <b-col cols="9" class="align-self-center" dir="rtl">
            <treeselect
              id="categories"
              :options="categories"
              :placeholder="label.pages.search"
              v-model="form.categories"
              :normalizer="normalizer"
              :flat="true"
              multiple
              :noOptionsText="label.errors.emptyList"
            ></treeselect>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="priority" class="ps_label">
              {{ label.form.priority }}
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-spinbutton
              id="priority"
              v-model="form.priority"
              size="sm"
              min="1"
              max="100"
            />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col cols="3">
            <label for="tags" class="ps_label">
              {{ label.form.tags }}
            </label>
          </b-col>
          <b-col cols="9">
            <v-select
              id="tags"
              v-model="form.tags"
              :closeOnSelect="false"
              size="sm"
              taggable
              multiple
              class="ps_select"
            >
              <template #no-options>
                {{ label.pages.Enter }}
              </template>
            </v-select>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="12">
            <drop-zone-custom
              v-if="refreshImage"
              mode="image"
              :isRequired="true"
              :edit="true"
              :editSrc="form.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col sm="3">
            <label for="Display" class="ps_label">
              {{ label.form.display }}
            </label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input id="Display" type="checkbox" v-model="form.isConfirm" />
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="editModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-warning"
              size="sm"
              class="mx-1"
              @click="editSound"
            >
              {{ label.buttons.saveChanges }}
            </b-button>
            <b-button
              v-else
              variant="ps-warning"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal dir="rtl" v-model="delModal" hide-header centered>
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1">
            {{ label.captions.deleteConfirm }}
            <br />
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="delModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="deleteSound"
            >
              {{ label.buttons.deleteConfirm }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-danger"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- show details Modal -->
    <b-modal dir="rtl" v-model="showModal" size="lg" centered>
      <template #modal-header>
        <h4 class="text-dark fw1">
          {{ label.pages.album }}
          <strong> «{{ itemTitle }}» </strong>
        </h4>
        <button
          class="ps-closeModalBtn text-dark"
          @click="showModal = false"
          id="closeShowModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeShowModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <DxDataGrid
          :show-row-lines="true"
          :show-column-lines="true"
          :show-borders="true"
          :row-alternation-enabled="true"
          :rtl-enabled="true"
          :data-source="sound"
          :columns="albumFields"
          :column-auto-width="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          column-resizing-mode="widget"
          :hover-state-enabled="true"
          noDataText="برای این آلبوم موردی ثبت نشده است"
          key-expr="id"
          class="ps_Table"
          :height="400"
        >
          <template #radif="{ data }">
            <div>
              {{ data.rowIndex + 1 }}
            </div>
          </template>
          <template #image="{ data }">
            <div>
              <img :src="data.data.imageAddress" class="ps_table_inside_img" />
            </div>
          </template>
          <template #actions="{ data }">
            <b-row class="justify-content-center">
              <b-col cols="auto" class="px-0">
                <button
                  @click="editSoundAlbum(data)"
                  :id="'editDetailBtnTlp-' + data.data.id"
                >
                  <b-icon
                    icon="dash-square-fill"
                    scale="1.1"
                    variant="ps-edit-icon"
                  ></b-icon>
                </button>
                <b-tooltip
                  boundary="#app"
                  noninteractive
                  triggers="hover"
                  :target="'editDetailBtnTlp-' + data.data.id"
                >
                  {{ label.buttons.edit }}
                </b-tooltip>
              </b-col>
              <b-col cols="auto" class="px-0 pe-2">
                <button
                  @click="delSoundAlbum(data)"
                  :id="'deleteDetailBtnTlp-' + data.data.id"
                >
                  <b-icon
                    icon="x-square-fill"
                    scale="1.1"
                    variant="ps-delete-icon"
                  ></b-icon>
                </button>
                <b-tooltip
                  boundary="#app"
                  noninteractive
                  triggers="hover"
                  :target="'deleteDetailBtnTlp-' + data.data.id"
                >
                  {{ label.buttons.delete }}
                </b-tooltip>
              </b-col>
            </b-row>
          </template>
          <DxLoadPanel :enabled="true" />
          <DxPaging :enabled="false" />
        </DxDataGrid>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="showModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addSoundAlbum"
            >
              {{ label.pages.newVoiceRecord }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!--  Add Details Modal -->
    <b-modal
      dir="rtl"
      v-model="addDetailModal"
      header-bg-variant="ps-success"
      centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.pages.newVoiceForAlbum }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="addDetailModal = false"
          id="closeAddDetailModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddDetailModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="title" class="ps_label">
              {{ label.form.title }}
              <span class="ps_label_star">*</span>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="title" size="sm" v-model="form.galleryTitle" />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="priority" class="ps_label">{{
              label.form.priority
            }}</label>
          </b-col>
          <b-col sm="9">
            <b-form-spinbutton
              id="priority"
              v-model="form.priority"
              size="sm"
              min="1"
              max="100"
            />
          </b-col>
        </b-row>
        <b-row v-if="dropZoneAction3" class="my-3">
          <b-col sm="3">
            <label for="sound" class="ps_label">{{ label.pages.audio }}</label>
          </b-col>
          <b-col sm="auto">
            <drop-zone-custom
              mode="sound"
              :isRequired="true"
              :add="dropZoneAction3"
              :edit="!dropZoneAction3"
            />
          </b-col>
        </b-row>
        <b-row v-if="!dropZoneAction3" class="my-3">
          <b-col sm="12">
            <drop-zone-custom
              mode="sound"
              :isRequired="true"
              :add="dropZoneAction3"
              :edit="!dropZoneAction3"
            />
          </b-col>
        </b-row>
        <b-row v-if="dropZoneAction2" class="my-3">
          <b-col sm="3">
            <label for="thumb" class="ps_label">{{
              label.pages.preview
            }}</label>
          </b-col>
          <b-col sm="auto">
            <drop-zone-custom
              mode="thumb"
              :isRequired="true"
              :add="dropZoneAction2"
              :edit="!dropZoneAction2"
              :editSrc="form.thumbImageAddress"
            />
          </b-col>
        </b-row>
        <b-row v-if="!dropZoneAction2" class="my-3">
          <b-col sm="12">
            <drop-zone-custom
              mode="thumb"
              :isRequired="true"
              :add="dropZoneAction2"
              :edit="!dropZoneAction2"
              :editSrc="form.thumbImageAddress"
            />
          </b-col>
        </b-row>
        <b-row class="my-4">
          <b-col sm="3">
            <label for="display" class="ps_label">{{
              label.form.display
            }}</label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input id="display" type="checkbox" v-model="form.isConfirm" />
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="addDetailModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addSoundToAlbum"
            >
              {{ label.pages.recordVoice }}
            </b-button>
            <b-button
              v-else
              variant="ps-success"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Details Modal -->
    <b-modal
      dir="rtl"
      v-model="editDetailModal"
      header-bg-variant="ps-warning"
      centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.pages.editVoice }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="editDetailModal = false"
          id="closeEditDetailModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditDetailModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="title" class="ps_label">
              {{ label.form.title }}
              <span class="ps_label_star">*</span>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="title" size="sm" v-model="form.galleryTitle" />
          </b-col>
        </b-row>
        <b-col>
          <b-row class="my-3">
            <b-col sm="3">
              <label for="priority" class="ps_label">
                {{ label.form.priority }}
              </label>
            </b-col>
            <b-col sm="9">
              <b-form-spinbutton
                id="priority"
                v-model="form.priority"
                size="sm"
                min="1"
                max="100"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row class="my-3">
            <b-col sm="12">
              <drop-zone-custom
                v-if="refreshImage3"
                mode="sound"
                :isRequired="true"
                :edit="true"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row class="my-3">
            <b-col sm="12">
              <drop-zone-custom
                v-if="refreshImage2"
                mode="thumb"
                :isRequired="true"
                :edit="true"
                :editSrc="form.thumbImageAddress"
                editText="پیش نمایش"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-row class="my-4">
          <b-col sm="3">
            <label for="display" class="ps_label">{{
              label.form.display
            }}</label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input id="display" type="checkbox" v-model="form.isConfirm" />
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="editDetailModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-warning"
              size="sm"
              class="mx-1"
              @click="editSoundFromAlbum"
            >
              {{ label.buttons.saveChanges }}
            </b-button>
            <b-button
              v-else
              variant="ps-warning"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Detail Confirm Modal -->
    <b-modal dir="rtl" v-model="delDetailModal" hide-header centered>
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1">
            {{ label.captions.deleteConfirm }}
            <br />
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="delDetailModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="deleteSoundAlbum"
            >
              {{ label.buttons.deleteConfirm }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-danger"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Trash Modal -->
    <b-modal
      dir="rtl"
      v-model="trashModal"
      size="lg"
      header-bg-variant="ps-danger"
      centered
    >
      <template #modal-header>
        <h4 class="text-white mb-0 fw1">
          {{ label.buttons.recycleBin }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="trashModal = false"
          id="trashModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="trashModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <DxDataGrid
          :show-row-lines="true"
          :show-column-lines="true"
          :show-borders="true"
          :row-alternation-enabled="true"
          :rtl-enabled="true"
          :data-source="deletedSounds"
          :columns="deletedFields"
          :column-auto-width="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          column-resizing-mode="widget"
          :hover-state-enabled="true"
          :noDataText="label.errors.emptyRecycle"
          key-expr="id"
          class="ps_Table"
          :height="400"
        >
          <template #radif="{ data }">
            <div>
              {{ data.rowIndex + 1 }}
            </div>
          </template>
          <template #actions="{ data }">
            <b-row class="justify-content-center">
              <b-col cols="auto" class="px-0">
                <button
                  @click="delConfirm(data)"
                  :id="'deleteBtnTlp-' + data.data.id"
                >
                  <b-icon
                    icon="x-square-fill"
                    scale="1.1"
                    variant="ps-delete-icon"
                  ></b-icon>
                </button>
                <b-tooltip
                  boundary="#app"
                  noninteractive
                  triggers="hover"
                  :target="'deleteBtnTlp-' + data.data.id"
                >
                  {{ label.buttons.delete }}
                </b-tooltip>
              </b-col>
              <b-col cols="auto" class="px-0">
                <button
                  @click="recycleConfirm(data)"
                  :id="'recycleBtnTlp-' + data.data.id"
                >
                  <b-icon
                    icon="arrow-up-right-square-fill"
                    scale="1.1"
                    variant="ps-add-icon"
                  ></b-icon>
                </button>
                <b-tooltip
                  boundary="#app"
                  noninteractive
                  triggers="hover"
                  :target="'recycleBtnTlp-' + data.data.id"
                >
                  {{ label.buttons.recycle }}
                </b-tooltip>
              </b-col>
            </b-row>
          </template>
          <DxSorting mode="multiple" />
          <DxLoadPanel :enabled="true" />
          <DxScrolling mode="virtual" />
        </DxDataGrid>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="trashModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <!-- <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="delAllConfirm"
            >
              {{ label.buttons.deleteAll }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="recycleAllConfirm"
            >
              {{ label.buttons.recycleAll }}
            </b-button>
          </b-col> -->
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataGridMixin } from "@/components/dataGrid/dataGridMixin";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import alert from "@/plugins/AlertMessages.js";
import dropZoneCustom from "@/components/DropZoneCustom";
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: "gallerySound",
  mixins: [dataGridMixin, contentLanguage],
  components: {
    Treeselect,
    dropZoneCustom,
  },
  data() {
    return {
      label,
      refreshImage: true,
      dropZoneAction: true,
      refreshImage2: true,
      dropZoneAction2: true,
      refreshImage3: true,
      dropZoneAction3: true,
      normalizer(node) {
        return {
          id: node.id,
          label: node.text,
          children: node.children,
        };
      },
      fields: [
        {
          cellTemplate: "radif",
          caption: "ردیف",
          allowSorting: false,
          allowFiltering: false,
          width: "80px",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "actions",
          caption: "عملیات",
          allowSorting: false,
          allowFiltering: false,
          width: "150",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "galleryTitle",
          width: "300",
          caption: "عنوان",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "image",
          caption: "تصویر",
          allowSorting: false,
          allowFiltering: false,
          width: "150",
          alignment: "center",
        },
        {
          dataField: "createdLocal",
          caption: "تاریخ ثبت",
          dataType: "string",
          alignment: "center",
        },
        {
          dataField: "isConfirm",
          caption: "وضعیت",
          dataType: "boolean",
          alignment: "center",
        },
      ],
      deletedFields: [
        {
          cellTemplate: "radif",
          caption: "ردیف",
          allowSorting: false,
          allowFiltering: false,
          width: "80px",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "galleryTitle",
          width: "300",
          caption: "عنوان",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "image",
          caption: "تصویر",
          allowSorting: false,
          allowFiltering: false,
          width: "150",
          alignment: "center",
        },
        {
          dataField: "createdLocal",
          caption: "تاریخ ثبت",
          dataType: "string",
          alignment: "center",
        },
        {
          dataField: "isConfirm",
          caption: "وضعیت",
          dataType: "boolean",
          alignment: "center",
        },
      ],
      addModal: false,
      form: {
        galleryTitle: "",
        galleryDescription: "",
        priority: "",
        sound: null,
        thumbnail: null,
        categories: [],
        tags: [],
        isConfirm: true,
        imageName: "",
        imageAddress: null,
        soundName: "",
        soundAddress: null,
        thumbImageName: null,
        thumbImageAddress: null,
      },
      editModal: false,
      editId: null,
      delModal: false,
      delId: null,
      delTitle: "",
      albumFields: [
        {
          cellTemplate: "radif",
          caption: "ردیف",
          allowSorting: false,
          allowFiltering: false,
          width: "70",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "actions",
          caption: "عملیات",
          allowSorting: false,
          allowFiltering: false,
          cssClass: "text-center align-middle",
        },
        {
          dataField: "title",
          caption: "عنوان",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "image",
          caption: "تصویر",
          allowSorting: false,
          allowFiltering: false,
          width: "150",
          alignment: "center",
        },
        {
          dataField: "isConfirm",
          width: "100",
          caption: "وضعیت",
          dataType: "boolean",
          alignment: "center",
        },
      ],
      showModal: false,
      itemId: null,
      itemTitle: "",
      addDetailModal: false,
      detailTitle: null,
      editDetailModal: false,
      editDetailId: null,
      delDetailModal: false,
      trashModal: false,
    };
  },
  computed: {
    ...mapGetters({
      postCheck: "postCheck",
      sounds: "baseX/sounds",
      sound: "baseX/sound",
      deletedSounds: "baseX/deletedSounds",
      categories: "baseX/categoryChilds",
      loadingBtn: "loadingBtn",
      imageUrl: "imageUrl",
      soundUrl: "soundUrl",
      thumbUrl: "thumbUrl",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.addModal = false;
        this.editModal = false;
        this.delModal = false;
        this.addDetailModal = false;
        this.editDetailModal = false;
        this.delDetailModal = false;
        this.reloadContent();
      }
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.refreshImage = false;
        this.dropZoneAction = false;
        this.form.imageName = this.imageUrl[0].fullPath;
        this.form.imageAddress = this.imageUrl[0].fileAddress;
        this.$nextTick(() => {
          this.refreshImage = true;
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
    thumbUrl() {
      if (this.thumbUrl && this.thumbUrl.length > 0) {
        this.refreshImage2 = false;
        this.dropZoneAction2 = false;
        this.form.thumbImageName = this.thumbUrl[0].fullPath;
        this.form.thumbImageAddress = this.thumbUrl[0].fileAddress;
        this.$nextTick(() => {
          this.refreshImage2 = true;
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
    soundUrl() {
      if (this.soundUrl && this.soundUrl.length > 0) {
        this.refreshImage3 = false;
        this.dropZoneAction3 = false;
        this.form.soundName = this.soundUrl[0].fullPath;
        this.form.soundAddress = this.soundUrl[0].fileAddress;
        this.$nextTick(() => {
          this.refreshImage3 = true;
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  methods: {
    show(item) {
      this.itemId = item.data.id;
      this.itemTitle = item.data.galleryTitle;
      this.$store.dispatch("baseX/getSoundById", this.itemId);
      this.showModal = true;
    },
    trashOpen() {
      let payload = "languageId=" + this.selectedLanguage;
      payload += "&isDelete=true";
      this.$store.dispatch("baseX/getDeletedSounds", payload);
      this.trashModal = true;
    },
    add() {
      this.reloadFields();
      this.dropZoneAction = true;
      this.$store.commit("setUrlsEmpty");
      this.getCategories();
      this.addModal = true;
    },
    addSound() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.galleryTitle && this.form.galleryTitle != "") {
        let formData = new FormData();
        if (this.form.galleryTitle) {
          formData.append("GalleryTitle", this.form.galleryTitle);
        }
        if (this.form.galleryDescription) {
          formData.append("GalleryDescription", this.form.galleryDescription);
        }
        if (this.form.priority) {
          formData.append("Priority", this.form.priority);
        }
        if (this.form.imageName) {
          formData.append("ImageName", this.form.imageName);
        }
        if (this.form.categories) {
          for (let i = 0; this.form.categories.length > i; i) {
            formData.append("Categories", this.form.categories[i]);
            i++;
          }
        }
        if (this.form.tags) {
          for (let i = 0; this.form.tags.length > i; i) {
            formData.append("Tags", this.form.tags[i]);
            i++;
          }
        }
        formData.append("IsConfirm", this.form.isConfirm);
        formData.append("languageId", this.selectedLanguage);
        this.$store.dispatch("baseX/addSound", formData);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit("setError", alert.error.empty);
      }
    },
    edit(item) {
      this.editId = item.data.id;
      this.form = {
        galleryTitle: item.data.galleryTitle,
        galleryDescription: item.data.galleryDescription,
        priority: item.data.priority,
        thumbnail: item.data.imageAddress,
        categories: item.data.categories,
        tags: item.data.tags,
        isConfirm: item.data.isConfirm,
        imageName: item.data.imageName,
        imageAddress: item.data.imageAddress,
      };
      this.getCategories();
      this.editModal = true;
    },
    editSound() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.galleryTitle && this.form.galleryTitle != "") {
        let formData = new FormData();
        if (this.form.galleryTitle) {
          formData.append("GalleryTitle", this.form.galleryTitle);
        }
        if (this.form.galleryDescription) {
          formData.append("GalleryDescription", this.form.galleryDescription);
        }
        if (this.form.priority) {
          formData.append("Priority", this.form.priority);
        }
        if (this.form.imageName) {
          formData.append("ImageName", this.form.imageName);
        }
        if (this.form.categories) {
          for (let i = 0; this.form.categories.length > i; i) {
            formData.append("Categories", this.form.categories[i]);
            i++;
          }
        }
        if (this.form.tags) {
          for (let i = 0; this.form.tags.length > i; i) {
            formData.append("Tags", this.form.tags[i]);
            i++;
          }
        }
        formData.append("IsConfirm", this.form.isConfirm);
        formData.append("languageId", this.selectedLanguage);
        const values = {
          id: this.editId,
          value: formData,
        };
        this.$store.dispatch("baseX/editSound", values);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit("setError", alert.error.empty);
      }
    },
    delConfirm(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.galleryTitle;
      this.delModal = true;
    },
    deleteSound() {
      this.$store.dispatch("baseX/deleteSound", this.delId);
    },
    addSoundAlbum() {
      this.reloadFields();
      this.dropZoneAction2 = true;
      this.dropZoneAction3 = true;
      this.$store.commit("setUrlsEmpty");
      this.addDetailModal = true;
    },
    addSoundToAlbum() {
      this.$store.commit("setLoadingBtn", true);
      if (
        this.form.galleryTitle &&
        this.form.galleryTitle != "" &&
        this.form.soundName
      ) {
        let formData = new FormData();
        formData.append("GalleryId", this.itemId);
        if (this.form.galleryTitle) {
          formData.append("Title", this.form.galleryTitle);
        }
        if (this.form.priority) {
          formData.append("Priority", this.form.priority);
        }
        if (this.form.soundName) {
          formData.append("FileName", this.form.soundName);
        }
        if (this.form.thumbImageName) {
          formData.append("ImageName", this.form.thumbImageName);
        }
        formData.append("IsConfirm", this.form.isConfirm);
        this.$store.dispatch("baseX/addSoundToAlbum", formData);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit("setError", alert.error.empty);
      }
    },
    editSoundAlbum(item) {
      this.editDetailId = item.data.id;
      this.form = {
        galleryTitle: item.data.title,
        priority: item.data.priority,
        sound: item.data.fileAddress,
        thumbnail: item.data.thumbImageAddress,
        isConfirm: item.data.isConfirm,
        imageName: item.data.imageName,
        soundAddress: item.data.fileAddress,
        soundName: item.data.fileName,
        thumbImageAddress: item.data.imageAddress,
        thumbImageName: item.data.imageName,
      };
      this.editDetailModal = true;
    },
    editSoundFromAlbum() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.galleryTitle && this.form.galleryTitle != "") {
        let formData = new FormData();
        formData.append("GalleryId", this.itemId);
        if (this.form.galleryTitle) {
          formData.append("Title", this.form.galleryTitle);
        }
        if (this.form.priority) {
          formData.append("Priority", this.form.priority);
        }
        if (this.form.soundName) {
          formData.append("FileName", this.form.soundName);
        }
        if (this.form.thumbImageName) {
          formData.append("ImageName", this.form.thumbImageName);
        }
        formData.append("IsConfirm", this.form.isConfirm);
        const editValues = {
          id: this.editDetailId,
          value: formData,
        };
        this.$store.dispatch("baseX/editSoundFromAlbum", editValues);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit("setError", alert.error.empty);
      }
    },
    delSoundAlbum(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.title;
      this.delDetailModal = true;
    },
    deleteSoundAlbum() {
      this.$store.dispatch("baseX/deleteSoundAlbum", this.delId);
    },
    getCategories() {
      if (this.selectedLanguage === 1) {
        this.$store.dispatch("baseX/getCategoryChilds", 6);
      } else if (this.selectedLanguage === 2) {
        this.$store.dispatch("baseX/getCategoryChilds", 106);
      } else if (this.selectedLanguage === 3) {
        this.$store.dispatch("baseX/getCategoryChilds", 206);
      } else if (this.selectedLanguage === 4) {
        this.$store.dispatch("baseX/getCategoryChilds", 306);
      } else if (this.selectedLanguage === 5) {
        this.$store.dispatch("baseX/getCategoryChilds", 406);
      }
    },
    reloadFields() {
      this.form = {
        galleryTitle: null,
        galleryDescription: "",
        priority: null,
        sound: null,
        thumbnail: null,
        categories: [],
        tags: [],
        soundName: null,
        soundAddress: null,
        thumbImageName: null,
        thumbImageAddress: null,
        isConfirm: true,
      };
    },
    reloadContent() {
      this.$store.dispatch("baseX/getSounds", this.selectedLanguage);
      if (this.itemId) {
        this.$store.dispatch("baseX/getSoundById", this.itemId);
      }
    },
  },
  mounted() {
    this.reloadContent();
  },
};
</script>
